import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AuditLogError {
  erroredTime: any;
  errorMessage: any;
}

@Component({
  selector: 'app-errors-visualizer',
  templateUrl: './errors-visualizer.component.html',
  styleUrls: ['./errors-visualizer.component.scss'],
})
export class ErrorsVisualizerComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { errors: AuditLogError[]; timezone: string }
  ) {}
  displayedColumns: string[] = ['erroredTime', 'errorMessage'];
  dataSource = this.data.errors;
  AuditLogErrorsData: AuditLogError[] = [];
  timeZoneSelected: string = this.data.timezone;

  ngOnInit(): void {
    this.AuditLogErrorsData = this.data.errors;
  }
}